import { UserAccountType } from "@/models/user-account-type.model";
import { type UserListItem, UserMapper } from "@/models/user.model";
import type {
  GetUserListPaginatedParams,
  UpdateUserRequestDto,
  UserId,
} from "@/spz-api/model";
import {
  activeUser,
  deactivateUser,
  getUserListPaginated,
  updateUser,
} from "@/spz-api/user/user";
import type { IUserRepository } from "../interfaces/user-repository.interface";

export class UserRepository implements IUserRepository {
  async getUsers(
    params: GetUserListPaginatedParams,
  ): Promise<{ total: number; items: UserListItem[] }> {
    const response = await getUserListPaginated(params);
    return {
      total: response.total,
      items: UserMapper.toListItems(response.data),
    };
  }
  async updateUserAccountType(
    id: string,
    accountType: UserAccountType,
  ): Promise<void> {
    try {
      const updateUserRequestDto: UpdateUserRequestDto = {
        accountType: UserAccountType.toUpdateApi(accountType),
      };
      await updateUser(id as unknown as UserId, updateUserRequestDto);
    } catch (error) {
      throw new Error("Failed to update user account type");
    }
  }
  async activateUser(id: string): Promise<void> {
    try {
      await activeUser(id as unknown as UserId);
    } catch (error) {
      throw new Error("Failed to activate user");
    }
  }

  async deactivateUser(id: string): Promise<void> {
    try {
      await deactivateUser(id as unknown as UserId);
    } catch (error) {
      throw new Error("Failed to deactivate user");
    }
  }
}
